import { TbClipboardText, TbBuilding, TbId, TbKey, TbMail, TbPhone } from "react-icons/tb";

export const PIX_TRANSFER_STEPS = [
  { id: 0, label: "Destino", description: "Chave ou copia e cola" },
  { id: 1, label: "Transferência", description: "Conta e valor" },
  { id: 2, label: "Confirmação", description: "Revise os dados" },
  { id: 3, label: "Senha", description: "Confirme com senha" },
  { id: 4, label: "Concluído", description: "Transferência finalizada" },
];

export const PIX_TRANSFER_MODES = [
  { id: "key", label: "Por chave", icon: TbKey },
  { id: "qrcode", label: "Copia e Cola", icon: TbClipboardText },
];

/** Explicit key-type chips (screenshot: CPF / CNPJ / E-mail / Celular / Aleatória). */
export const PIX_KEY_TYPE_OPTIONS = [
  { key: "cpf", title: "CPF", icon: TbId, placeholder: "000.000.000-00" },
  { key: "cnpj", title: "CNPJ", icon: TbBuilding, placeholder: "00.000.000/0000-00" },
  { key: "email", title: "E-mail", icon: TbMail, placeholder: "email@exemplo.com" },
  { key: "phone", title: "Celular", icon: TbPhone, placeholder: "(00) 00000-0000" },
  { key: "randomKey", title: "Aleatória", icon: TbKey, placeholder: "00000000-0000-0000-0000-000000000000" },
];
